import styled from 'styled-components'
import { CONTRACTS, LockType } from '../config'
import { fmtUnits } from '../format'
import { useLockFees } from '../fees'
import { AddressLine, Panel, PanelTitle, Stack, VerifiedBadge } from '../ui'

const Grid = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: minmax(0, 1fr);
  ${({ theme }) => theme.mediaQueries.md} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`
const Card = styled.div`
  display: grid;
  gap: 12px;
  align-content: start;
  padding: 16px;
  border-radius: 16px;
  background: rgba(5, 7, 19, 0.5);
  border: 1px solid ${({ theme }) => theme.colors.cardBorder};
  h3 {
    margin: 0;
    font-family: 'Gabarito', 'Gabarito Fallback', system-ui, sans-serif;
    font-weight: 800;
    font-size: 18px;
    line-height: 24px;
  }
  p {
    margin: 0;
    font-size: 14px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.textSubtle};
  }
`

function Locker({ type }: { type: LockType }) {
  const c = CONTRACTS[type]
  const fees = useLockFees(type)
  return (
    <Card data-testid={`locker-${type}`}>
      <h3>{c.label}</h3>
      <p>
        Holds {c.holds}. {type === 'v3' ? 'The lock owner collects trading fees; nobody can pull the position before the date.' : 'Plain and vesting locks. Nobody can withdraw before the release dates.'}
      </p>
      <AddressLine address={c.address} full />
      <VerifiedBadge address={c.address} />
      {/* both prices 0 (free since 2026-10-09): nothing is paid to CADINU; any non-zero price shows the priced line */}
      {fees.native === 0n && fees.cbon === 0n ? (
        <p data-testid={`fee-${type}`}>
          Fee for a new lock: <b style={{ color: '#dfe9ff' }}>free</b>, you pay only the network fee. Read live from the contract.
        </p>
      ) : (
        <p data-testid={`fee-${type}`}>
          Fee for a new lock:{' '}
          <b style={{ color: '#dfe9ff' }}>{fees.native !== undefined ? `${fmtUnits(fees.native, 18, true)} BNB` : fees.failed ? 'could not be read' : 'reading…'}</b>
          {fees.cbon !== undefined ? <> or <b style={{ color: '#dfe9ff' }}>{fmtUnits(fees.cbon, 18, true)} CBON</b></> : null}. Read from the contract, paid to CADINU; it never touches what you lock.
        </p>
      )}
    </Card>
  )
}

/** Where the funds are held: the two lockers, their verified sources and their live fees. */
export default function ContractsPanel() {
  return (
    <Panel data-testid="contracts-panel">
      <Stack $gap={16}>
        <PanelTitle icon="shieldCheck">Where the funds are held</PanelTitle>
        <Grid>
          <Locker type="v3" />
          <Locker type="v2" />
        </Grid>
      </Stack>
    </Panel>
  )
}
